var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { attrs: { href: _vm.urlWishList } }, [
    _c("button", { staticClass: "shop-nav__btn" }, [
      _c("i", { staticClass: "icon__wish-list" }, [
        _c(
          "span",
          {
            staticClass: "shop-nav__wish-list-wrap",
            class: {
              "shop-nav__wish-list-wrap--visible": _vm.wishListCount > 0,
            },
          },
          [
            _c("span", { staticClass: "shop-nav__wish-list-amount" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.wishListCount) +
                  "\n                "
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }